import styled from 'styled-components'

const IconTextContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export default IconTextContainer
